import { styled } from "@mui/material/styles";
import { autocompleteClasses } from "@mui/material/Autocomplete";
import { Button } from "@mui/material";

export const StyledInputWrapper = styled("div")(
  ({ theme }) => `
  background-color: #282828; /* TODO - change to theme color Neutral/700 text */
  border: 1px solid #404040; /* TODO - change to theme color Neutral/500 */
  color: ${theme.wsc.palette.neutral[200]};
  border-radius: ${theme.wsc.radius.m};
  padding: ${theme.wsc.spacing[0]} ${theme.wsc.spacing[1]};
  gap: ${theme.wsc.spacing[0]};
  display: flex;
  align-items: center;
  justify-content: space-between;

  &:hover {
    background-color: #333; /* TODO - change to theme color Neutral/600 */
    border-color: #333; /* TODO - change to theme color Neutral/600 */
    input {
        background-color: #333; /* TODO - change to theme color Neutral/600 */
    }
  }

  &.${autocompleteClasses.focused} {
    border-color: ${theme.wsc.palette.neutral[0]};
    background-color: #404040; /* TODO - change to theme color Neutral/500 */
    input {
        background-color: #404040; /* TODO - change to theme color Neutral/500 */
    }
  }

  &.Autocomplete-Error{
    border-color: ${theme.wsc.palette.warning[300]};
    }

    &.Autocomplete-Disabled {
        background-color: #181818; /* TODO - change to theme color Neutral/800 */
        border-color: #404040; /* TODO - change to theme color Neutral/500 */
        color: #8E8E8E; /* TODO - change to theme color Neutral/300 */

        input {
            background-color: #181818; /* TODO - change to theme color Neutral/800 */
            color: #8E8E8E; /* TODO - change to theme color Neutral/300 */
        }
    }

    &.Autocomplete-Filled {
        input {
            color: ${theme.wsc.palette.neutral[100]};
        }
    }

  & input {
    background-color: #282828; /* TODO - change to theme color Neutral/700 text */
    color: ${theme.wsc.palette.neutral[200]};
    box-sizing: border-box;
    line-height: 1.5rem;
    width: 0;
    min-width: 30px;
    flex-grow: 1;
    border: 0;
    outline: 0;
    margin: 0;
    padding:0;
    caret-color: ${theme.wsc.palette.primary[300]}
  } 
`,
);

export const StyledAutocompleteInput = styled("input")`
  && {
    min-width: 15px;
  }
`;

export const StyledClearIndicator = styled(Button)`
  outline: 0;
  box-shadow: none;
  border: 0;
  background-color: transparent;
  align-self: center;
  padding: 0;
  margin: 0;
  min-width: 0;
  color: ${({ theme }) => theme.wsc.palette.neutral[100]};
`;

export const StyledPopupIndicator = styled(Button)(
  ({ theme }) => `
      outline: 0;
      box-shadow: none;
      border: 0;
      background-color: transparent;
      align-self: center;
      padding: 0;
      margin: 0;
      min-width:0;
      color: ${theme.wsc.palette.neutral[100]};

      &.DoubleArrow {
        display: flex;
        flex-direction: column;
        align-items: center;

        > span {
            height: ${theme.wsc.spacing[1]};
            line-height: ${theme.wsc.spacing[1]};
        }
      }

      > span {
        line-height: 1.571rem;
      }
  
      &.${autocompleteClasses.popupIndicatorOpen} > span {
        transform: rotate(180deg);
      }
    `,
);
